export const getAmountWithCurrency = (amount: number, currency: string): string => `${amount.toFixed(2)} ${currency}`;
